import { render } from "./WuCaiGouShenPi.vue?vue&type=template&id=8bc062e6"
import script from "./WuCaiGouShenPi.vue?vue&type=script&lang=js"
export * from "./WuCaiGouShenPi.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__